<template>
  <div @click ="closeNav" class="wrap">
      <nav class="animate__animated animate__fadeIn">
          <ul class="display-flex">
              <li>Home</li>
              <li>Feedback</li>
              <li>Blog</li>
              <li>Contact</li>
          </ul>
      </nav>
  </div>
</template>

<script>
import 'animate.css'
export default {
  name:'Cover',
  methods:{
      closeNav(){
          this.$emit('closeNavBar')
      }
  }
}
</script>

<style lang="scss" scoped>
  .wrap{
      width:100%;
      height: 110vh;
      position: fixed;
      left:0px;
      z-index:200;
      backdrop-filter: brightness(0.4);
      nav{
         width:75%;
         transform: translateY(20vh);
         margin:0 auto;
         background:white;
         border-radius: 10px;
         padding:30px 30px;
         ul{
             flex-direction: column;
             align-items: flex-start;
             li{
                 font-family: 'DM sans';
                 list-style-type: none;
                 font-size: 1.2em;
                 margin:10px 0px;
             }
         }
      }
  }
  @media (min-width:600px){
      .wrap{
          nav{
              width:400px;
          }
      }
  }
</style>